import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TabControlService } from './services/tab-control.service';
import { NotificationService } from './services/notification.service';
import { EstateControlService } from './services/estate-control.service';
import { NavigationEnd, Router } from '@angular/router';
import { generateWhatsappChatLinkMessage } from './util/Helper';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from './components/modal/modal.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('modalAnimation', [
      state('closed', style({
        opacity: 0,
        transform: 'scale(0) translateY(100%)',
      })),
      state('open', style({
        opacity: 1,
        transform: 'scale(1) translateY(0)',
      })),
      transition('closed <=> open', animate('300ms ease-in-out')),
    ]),
  ],
})
export class AppComponent implements OnInit {
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;

  
  title = 'milele-trust-frontend';

  mPesaPath: string = `${environment.hRef}assets/m_pesa.png`;
  retryPaymentText: string = 'Sorry, we could not verify your M-Pesa payment.';
  retryQuestionText: string = 'Did you complete it successfully?';
  service: TabControlService | EstateControlService = this.tabControlService;

  constructor(
    private readonly tabControlService: TabControlService,
    private readonly estateControlService: EstateControlService,
    private readonly router: Router,
    private readonly dialog: MatDialog,
    private readonly notificationService: NotificationService
  ) {

    }

  ngOnInit() {
    this.router.events.subscribe(res=>{
      if(res instanceof NavigationEnd){
        if (res.url.includes('estate-planning')) {
          this.service = this.estateControlService;
          this.notificationService.nextRoute = 'estate-planning/set-up';
        } else {
          this.estateControlService.showChecklist = false;
          this.service = this.tabControlService;
          this.notificationService.nextRoute = 'trust-fund/set-up';
        }
      }
    })
  }

  get loading(): boolean {
    return this.notificationService.loading;
  }
  get stkLoading(): boolean {
    return this.service.stkLoading;
  };

  get stkTimeout(): boolean {
    return this.service.stkTimeout;
  };

  get requestingSTK(): boolean {
    return this.service.requestingSTK;
  }
  set requestingSTK(value: boolean) {
    this.service.requestingSTK = value;
  }

  get enterPinText(): string {
    return this.service.stkPinText;
  };

  get stkMessage(): string {
    return this.service.stkMessage;
  }

  get showChecklist(): boolean {
    return this.estateControlService.showChecklist;
  }

  get resetSTK(): ()=> void {
    return this.service.resetSTK;
  };

  isModalOpen = false;

  toggleChecklistModal() {
    this.isModalOpen = !this.isModalOpen;
    if (this.isModalOpen) this.openChecklistModal();
    else this.notificationService.closeAllModals();
  }

  mpesaPayment(mode: 0 | 1): void{
    this.service.stkMode = mode;
    this.service.mpesaPayment();
  };

  closeSTKPopup(): void {
    this.service.stkLoading = false;
    this.resetSTK();
  }
  openWhatsappChat(): void {
    let name = '';

    if (this.service == this.estateControlService) {
      if (this.service.planType == 1) {
        if (this.service.testators[0]?.FirstName
          && this.service.testators[0].FirstName.length > 0)
            name = this.service.testators[0].FirstName;
      } else {
        if (this.service.settlors[0]?.FirstName
          && this.service.settlors[0].FirstName.length > 0)
            name = this.service.settlors[0].FirstName;
      }
    } else if (this.service == this.tabControlService) {
      if (this.service.basicData
        &&this.service.basicData?.FirstName.length > 0)
          name = this.service.basicData.FirstName;
    }
    const URL = generateWhatsappChatLinkMessage(name);
    window.open(URL, "_blank");
  }

  openChecklistModal = (): void => {
    const dialogRef = this.dialog.open(ModalComponent, {
      height: '98%',
      maxWidth: '1400px',  // Maximum width of the modal
      maxHeight: '1100px',
      data: {
        contentTemplate: this.modalContent,
        modalTitle: 'Family Trust Creation Checklist',
        buttonText: 'Dismiss'
      },
      disableClose: false // Disable closing when clicking outside the modal
    });

    this.notificationService.addModal(dialogRef);

    dialogRef.afterClosed().subscribe(() => {
      this.notificationService.removeModal(dialogRef);
      this.isModalOpen = false;
    });
  }
}
